import { Component, OnInit, OnDestroy } from '@angular/core';
import { ZpDataService } from './../services/zp-data.service';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { Subscription } from 'rxjs';
import { DelegateHelpers } from './../helpers/delegate-helpers';
import { Router, NavigationEnd } from '@angular/router';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-shared-plans',
    templateUrl: './shared-plans.component.html',
    styleUrls: ['./shared-plans.component.scss'],
    standalone: false
})
export class SharedPlansComponent implements OnInit, OnDestroy {
  private clientId;
  public allMySharedPlans: {}[];
  public filteredSharePlans: {}[];
  public headElements = ['First', 'Last'];
  public subscription: Subscription;
  public planCountText = "No plans";
  public myUser: IUser;
  public chosenPlan;
  public showClient = false;
  public mySubscription: Subscription;
  public delegateId: string;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public sharedPlansList;

  constructor(private zenplansDataProvider: ZpDataService,
    private userInfo: UserInfoService,
    private delegateHelpers: DelegateHelpers,
    private router: Router,
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService) {
    this.subscription = this.userInfo.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);

    });
    // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   return false;
    // };
    // this.mySubscription = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     // Trick the Router into believing it's last link wasn't previously loaded
    //     this.router.navigated = false;
    //   }
    // });
  }

  // async getMySharedPlans() {
  //   let allMySharedPlans =
  //     await this.zenplansDataProvider.getMySharedPlans(this.myUser);
  //   if (this.allMySharedPlans && this.allMySharedPlans.length > 0) {
  //     this.planCountText = this.allMySharedPlans.length > 1 ? this.allMySharedPlans.length + " plans have" :
  //       "1 plan has";
  //   }
  //   return allMySharedPlans;
  // }

  async ngOnInit() {
    this.activeTheme = this.themeService.active
    if (this.activeTheme.name != 'defaultTheme') {
      this.isDefaultTheme = false;
    }
    //this.allMySharedPlans = await this.getMySharedPlans();
    if (this.myUser.delegate) {
      this.delegateId = this.myUser.delegate["delegateId"]
      //when the delegate looked at his shared plans and did a backspace.
    }
    else {//when the delegate enters the shared plans for the first time
      this.delegateId = this.myUser.Id;
    }

    this.allMySharedPlans =
      await this.zenplansDataProvider.getMySharedPlans(this.delegateId);
    if (this.allMySharedPlans && this.allMySharedPlans.length > 0) {
      this.planCountText = this.allMySharedPlans.length > 1 ? this.allMySharedPlans.length + " plans have" :
        "1 plan has";
    }
  }

  filterPlans($event) {
    this.filteredSharePlans = [];
    let nameSeek = $event.target.value;
    if (nameSeek.length == 0) {
      this.showClient = false;
      return this.filteredSharePlans;
    }
    this.filteredSharePlans = this.allMySharedPlans.filter((plan) =>
      plan['clientLastName'].includes(nameSeek));
    if (!this.filteredSharePlans || this.filteredSharePlans.length == 0) {
      this.showClient = false;
    }

  }

  view($event, plan) {
    this.chosenPlan = plan;
    this.showClient = true;
  }

  async seeSharedPlan($event, section) {
    switch (section) {
      case "dashboard":
        //if(this.chosenPlan[""])
        //this.delegateHelpers.delegateLogIntoUser(this.chosenPlan, this.chosenPlan["clientId"])
        await this.delegateHelpers.delegateChooseSharedPlan(this.chosenPlan, this.myUser);
        console.log('myUser - ', this.myUser);
        this.router.navigate(['/my-dashboard']);
        break;
      case "assets":
        if (this.chosenPlan["assetsPermission"] != "now" &&
          this.chosenPlan["assetsPermission"] != "contributor") {
          this.router.navigate(['/request-access']);
          break;
        }
        //this.delegateHelpers.delegateLogIntoUser(this.chosenPlan, this.chosenPlan["clientId"])
        await this.delegateHelpers.delegateChooseSharedPlan(this.chosenPlan, this.myUser);
        this.router.navigate(['/my-assets']);
        break;
      case "debts":
        if (this.chosenPlan["debtsPermission"] != "now" &&
          this.chosenPlan["debtsPermission"] != "contributor") {
          this.router.navigate(['/request-access']);
          break;
        }
        //this.delegateHelpers.delegateLogIntoUser(this.chosenPlan, this.chosenPlan["clientId"])
        await this.delegateHelpers.delegateChooseSharedPlan(this.chosenPlan, this.myUser);
        this.router.navigate(['/my-debts']);
        break;
      case "daily life":
        if (this.chosenPlan["dailyLifePermission"] != "now" &&
          this.chosenPlan["dailyLifePermission"] != "contributor") {
          this.router.navigate(['/request-access']);
          break;
        }
        //this.delegateHelpers.delegateLogIntoUser(this.chosenPlan, this.chosenPlan["clientId"])
        await this.delegateHelpers.delegateChooseSharedPlan(this.chosenPlan, this.myUser);
        this.router.navigate(['/my-daily-life']);
        break;
      case "digital life":
        if (this.chosenPlan["digitalLifePermission"] != "now" &&
          this.chosenPlan["digitalLifePermission"] != "contributor") {
          this.router.navigate(['/request-access']);
          break;
        }
        //this.delegateHelpers.delegateLogIntoUser(this.chosenPlan, this.chosenPlan["clientId"])
        await this.delegateHelpers.delegateChooseSharedPlan(this.chosenPlan, this.myUser);
        this.router.navigate(['/my-digital-life']);
        break;
      case "wishes":
        if (this.chosenPlan["wishesPermission"] != "now" &&
          this.chosenPlan["wishesPermission"] != "contributor") {
          this.router.navigate(['/request-access']);
          break;
        }
        //this.delegateHelpers.delegateLogIntoUser(this.chosenPlan, this.chosenPlan["clientId"])
        await this.delegateHelpers.delegateChooseSharedPlan(this.chosenPlan, this.myUser);
        this.router.navigate(['/my-wishes']);
        break;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    //this.mySubscription.unsubscribe();
  }
}
